var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInvitations = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.2 237.4C149.7 237.4 147.4 236 146.3 233.7L115.2 169.8L51.3 138.7C48 137.1 46.7 133.1 48.3 129.9C49 128.4 50.3 127.3 51.8 126.7L215.7 60.8C219.1 59.4 222.9 61.1 224.3 64.5C224.9 66.1 224.9 67.9 224.3 69.4L158.4 233.3C157.4 235.7 155.1 237.3 152.5 237.4H152.2ZM70.5 133.5L123 159C124.3 159.6 125.4 160.7 126.1 162.1L151.7 214.6L206.2 78.9L70.5 133.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.1 171.5C116.4 171.5 113.5 168.5 113.5 164.9C113.5 163.1 114.2 161.5 115.4 160.2L213.4 62.2C216 59.6 220.2 59.6 222.7 62.2C225.2 64.8 225.3 69 222.7 71.5L124.7 169.5C123.5 170.8 121.8 171.5 120.1 171.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInvitations, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/invitations.9ad848c3.svg";
export { ForwardRef as ReactComponent };